import { useState } from 'react';
import * as S from './styles';
import useOnclickOutside from 'react-cool-onclickoutside';
import PropTypes from 'prop-types';

import { FaInfoCircle } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

export const ToolTip = ({
    children = null,
    mobileDirection = 'right',
    desktopDirection = 'right',
    content,
    withBorder = false,
}) => {
    const [active, setActive] = useState(false);
    const ref = useOnclickOutside(() => setActive(false));

    const isMobile = useMediaQuery({ maxWidth: 1280 });
    const direction = isMobile ? mobileDirection : desktopDirection;

    return (
        <S.Root ref={ref} $withBorder>
            <div className='Tooltip-Wrapper'>
                <FaInfoCircle onClick={() => setActive(!active)} />
                {children}
                {active && (
                    <div
                        className={`Tooltip-Tip ${direction} ${
                            withBorder ? 'tool-tip-border' : ''
                        }`}
                    >
                        {content}
                    </div>
                )}
            </div>
        </S.Root>
    );
};

ToolTip.propTypes = {
    children: PropTypes.any,
    content: PropTypes.string,
    mobileDirection: PropTypes.string,
    desktopDirection: PropTypes.string,
};
